import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { financialItemStyles } from "./financialItemStyle";
import TableContainer from "@material-ui/core/TableContainer";
import "../Print.css";
type VoidReturnDataProps = {
  voidReturn: Array<object>;
};

export const VoidReturn: FunctionComponent<VoidReturnDataProps> = (voidReturn: {
  [key: string]: any;
}) => {
  //console.log("report",voidReturn.voidReturn.item_return_cou)
  // console.log("reportcount",eodReportDetails.eodReportDetails.item_void_count)
  const classes = financialItemStyles();
  return (
    <Grid container>
      <Grid item xs={12}>
        <TableContainer>
          <Table
            className={classes.table}
            size="small"
            aria-label="a dense table"
          >
            <TableHead className={classes.tableRow}>
              <TableRow style={{ height: "3em" }}>
                <TableCell
                  className={classes.headColor}
                  scope="row"
                  style={{ width: "35%" }}
                >
                  Type
                </TableCell>
                <TableCell align="center" className={classes.voidReturnHead}>
                  Number of Transactions
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="left" className={classes.columnWeight}>
                  Item Return{" "}
                </TableCell>
                <TableCell align="center" className={classes.tableContent}>
                  {voidReturn.voidReturn.item_return_count}
                </TableCell>
                <TableCell align="right" className={classes.columnWeight}>
                  {voidReturn.voidReturn.item_return_total}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell align="left" className={classes.columnWeight}>
                  Transaction Return
                </TableCell>
                <TableCell align="center" className={classes.tableContent}>
                  {voidReturn.voidReturn.trans_return_count}
                </TableCell>
                <TableCell align="right" className={classes.columnWeight}>
                  {voidReturn.voidReturn.trans_return_total}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell align="left" className={classes.columnWeight}>
                  Item Void
                </TableCell>
                <TableCell align="center" className={classes.tableContent}>
                  {voidReturn.voidReturn.item_void_count}
                </TableCell>
                <TableCell align="right" className={classes.columnWeight}>
                  {voidReturn.voidReturn.item_void_total}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell align="left" className={classes.columnWeight}>
                  Transaction Void
                </TableCell>
                <TableCell align="center" className={classes.tableContent}>
                  {voidReturn.voidReturn.trans_void_count}
                </TableCell>
                <TableCell align="right" className={classes.columnWeight}>
                  {voidReturn.voidReturn.trans_void_total}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
